import { createClient } from '@supabase/supabase-js';

// ── Environment variables (injected by Vite at build time) ──────────────────
// Trim whitespace so that copy-paste issues in Cloudflare dashboard don't break the key.
const supabaseUrl     = (import.meta.env.VITE_SUPABASE_URL     ?? '').trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim();

// Export for diagnostics (e.g. SuperAdminDashboard env-check panel)
export const __env = {
  hasUrl:     supabaseUrl.length > 0,
  hasKey:     supabaseAnonKey.length > 0,
  urlPreview: supabaseUrl   ? supabaseUrl.slice(0, 40)   : '(missing)',
  keyPreview: supabaseAnonKey ? `${supabaseAnonKey.slice(0, 12)}…${supabaseAnonKey.slice(-8)}` : '(missing)',
  keyLength:  supabaseAnonKey.length,
};

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[Axelio] Missing Supabase env vars – VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set at build time.',
    'Make sure both variables are added to Cloudflare Pages → Settings → Environment variables BEFORE triggering a deployment.',
  );
}

// "Remember me" support: when the user signed in without "Remember me", the
// session token lives only in sessionStorage (cleared when the tab closes).
const isSessionOnly = sessionStorage.getItem('axelio-session-only') === '1';
const authStorage: Storage = isSessionOnly ? sessionStorage : localStorage;

// Create Supabase client with proper configuration
// Use placeholder values so the app loads (and shows an error) rather than crashing outright.
export const supabase = createClient(
  supabaseUrl  || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession:   true,
      detectSessionInUrl: true,
      storageKey: 'axelio-auth-token',
      storage:    authStorage,
    },
    db: {
      schema: 'public',
    },
    global: {
      headers: {
        'X-Client-Info': 'axelio-web',
      },
    },
  },
);

// Auth helper functions
export const authHelpers = {
  getSession: () => supabase.auth.getSession(),
  getUser:    () => supabase.auth.getUser(),
  signOut:    () => supabase.auth.signOut(),
} as const;
